import hress5uLabels from 'assets/labels/hress5u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hress5uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        staappr: '',
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number(),
        desc_codpos_temploy1: faker.name.jobTitle(),
        desc_codpos: faker.name.jobTitle(),
        desc_codcomp: faker.name.jobType(),
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: 'Test Detail',
        codappr: faker.lorem.word(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      codcomp: faker.lorem.word() + ' - ',
      desc_codcomp: faker.name.jobType(),
      desc_codpos: faker.name.jobTitle(),
      desc_codjob: faker.name.jobTitle(),
      remarks: 'Test Detail',
      dtestart: moment().format('DD/MM/YYYY')
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        id: i,
        desc_codcomp: faker.lorem.word(),
        desc_codpos: faker.lorem.word(),
        desc_codjob: faker.lorem.word(),
        qtyreq: faker.random.number().toString().substr(0, 1),
        dteopen: moment().format('DD/MM/YYYY'),
        dteclose: moment().format('DD/MM/YYYY'),
        codpos: faker.lorem.word(),
        codjob: faker.lorem.word(),
        numreqst: faker.lorem.word()
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      }
    }
  },
  popup1DetailTab2 () {
    let mockPopup1Tab1 = {
      numreqst: faker.lorem.word(),
      codpos: faker.lorem.word(),
      desc_codpos: faker.lorem.words(),
      codjob: faker.lorem.word(),
      desc_codjob: faker.lorem.word(),
      desnoffi: faker.lorem.word(),
      flgjob: faker.lorem.word(),
      flgcond: faker.lorem.word(),
      syncond: faker.lorem.word(),
      desnote: 'Test Popup'
    }

    return {
      tab1: mockPopup1Tab1
    }
  },
  popup2DetailTab2 () {
    let mockPopup2Tab1 = {
      codjob: faker.lorem.word(),
      desc_codjob: faker.lorem.words(),
      desjob: faker.lorem.word(),
      amtcolla: faker.lorem.word(),
      qtyguar: faker.random.number(),
      qtyyrsur: faker.random.number(),
      syncond: faker.lorem.word()
    }
    let mockPopup2Tab2Rows = []
    const mockPopup2Tab2Total = 1
    for (var a = 1; a <= mockPopup2Tab2Total; a++) {
      mockPopup2Tab2Rows.push({
        id: a,
        codjob: faker.lorem.word(),
        desc_codjob: faker.lorem.word(),
        itemno: faker.lorem.word(),
        namitem: faker.lorem.word(),
        descrip: 'Test Popup'
      })
    }
    let mockPopup2Tab3Rows = []
    const mockPopup2Tab3Total = 1
    for (var b = 1; b <= mockPopup2Tab3Total; b++) {
      mockPopup2Tab3Rows.push({
        id: b,
        codjob: faker.lorem.word(),
        desc_codjob: faker.lorem.word(),
        itemno: faker.lorem.word(),
        namitem: faker.lorem.word(),
        descrip: 'Test Popup'
      })
    }
    let mockPopup2Tab4Rows = []
    const mockPopup2Tab4Total = 1
    for (var c = 1; c <= mockPopup2Tab4Total; c++) {
      mockPopup2Tab4Rows.push({
        id: c,
        codjob: faker.lorem.word(),
        desc_codjob: faker.lorem.word(),
        seqno: faker.lorem.word(),
        codedlv: faker.lorem.word(),
        desc_codedlv: faker.lorem.words(),
        codmajsb: faker.lorem.word(),
        desc_codmajsb: faker.lorem.words(),
        numgpa: faker.lorem.word()
      })
    }

    return {
      tab1: mockPopup2Tab1,
      tab2: {
        table: {
          total: mockPopup2Tab2Total,
          rows: mockPopup2Tab2Rows
        }
      },
      tab3: {
        table: {
          total: mockPopup2Tab3Total,
          rows: mockPopup2Tab3Rows
        }
      },
      tab4: {
        table: {
          total: mockPopup2Tab4Total,
          rows: mockPopup2Tab4Rows
        }
      }
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hress5u/mocker.js